import React, { PureComponent } from 'react';

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  Cell
} from "recharts";
import { Loader } from 'react-loaders';

import { getRequest } from '../../../../../../api/ApiService';

import {
  Wrapper,
  PreTitle,
  Title,
  Text,
  ContentContainer,
  ContentTitle,
  ContentFlexColumns,
  ContentRightColumn,
  ChartDataLabel
} from '../../../components/ui';

import DataDetails from '../../../components/data-details';

const chartColors = [
  '#81c991',
  '#fd9595'
]

class MostLeastValuablePlayers extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      users: [],
      mostValuableUsers: [],
      leastValuableUsers: [],
      extraDetailsTitle: 'Most Valuable Players',
      extraDetailsColor: chartColors[0],
      extraDetailsData: [],
      loaded: false
    };
  }

  componentDidMount() {
    const { surveysStatsByUser } = this.props;
    getRequest(
      `${process.env.REACT_APP_API_URL}users`,
    )
      .then(res => {
        const users = res.body;
        const mostValuable = surveysStatsByUser.filter(i => {
          return i.most_valuable_percentage > 66
        });

        const mostValuableUsers = mostValuable.map(item => {
          const user = users.find(user => user.id === item.user_id);
          return `${user.first_name} ${user.last_name}`
        });

        const leastValuable = surveysStatsByUser.filter(i => {
          return i.work_again_percentage <= 40
        });

        const leastValuableUsers = leastValuable.map(item => {
          const user = users.find(user => user.id === item.user_id);
          return `${user.first_name} ${user.last_name}`
        });

        this.setState({
          mostValuableUsers,
          leastValuableUsers,
          extraDetailsData: mostValuableUsers,
          loaded: true
        });
      })
      .catch(err => { });
  }

  changeExtraDetails = (title, color, data) => {
    this.setState({
      extraDetailsTitle: title,
      extraDetailsColor: color,
      extraDetailsData: data
    });
  }

  render() {
    const { gamesTeamplayers } = this.props;
    const {
      mostValuableUsers,
      leastValuableUsers,
      extraDetailsTitle,
      extraDetailsColor,
      extraDetailsData,
      loaded
    } = this.state;

    const mostValuableCount = mostValuableUsers.length;

    const leastValuableUsersCount = leastValuableUsers.length;

    const chartData = [
      {
        value: mostValuableCount,
        color: chartColors[0],
        title: 'Most Valuable Players'
      },
      {
        value: leastValuableUsersCount,
        color: chartColors[1],
        title: 'Least Valuable Players'
      }
    ];

    return loaded ? (
      <Wrapper>
        <PreTitle>Individual</PreTitle>
        <Title>Most & Least Valuable Players</Title>
        <Text>
          <p>Here are the most and least valuable players in the exercise.</p>
          <p><strong>MVP</strong></p>
          <p><b>{mostValuableCount}</b> students out of <b>{gamesTeamplayers.length}</b> were the most valuable team member on their respective teams. Their teammates unanimously agreed that these students contributed the most impact on their team’s success.</p>
          <p><strong>LVP</strong></p>
          <p>However, there were <b>{leastValuableUsersCount}</b> students that made the least impact on their respective teams. Students that fall into this category tend to have communication, work ethic, and/or dominant personalities issues.</p>
        </Text>
        <ContentContainer>
          <ContentTitle>Individual Contributions</ContentTitle>
          <ContentFlexColumns withFloatinDetailsBlock={true} withPadding={true}>
            <ResponsiveContainer width={170} height={160}>
              <BarChart
                data={chartData}
                margin={{ top: 32, left: 10, right: 20, bottom: 38 }}
              >
                <Bar
                  barSize={32}
                  dataKey="value"
                >
                  {
                    chartData.map((item, index) => (
                      <Cell key={index} fill={item.color} />
                    ))
                  }
                </Bar>
              </BarChart>
            </ResponsiveContainer>
            <ContentRightColumn>
              <ChartDataLabel
                onClick={() => this.changeExtraDetails(chartData[0].title, chartColors[0], mostValuableUsers)}
              >
                {`${chartData[0].title} (${mostValuableCount})`}
              </ChartDataLabel>
              <ChartDataLabel
                color={chartColors[1]}
                onClick={() => this.changeExtraDetails(chartData[1].title, chartColors[1], leastValuableUsers)}
              >
                {`${chartData[1].title} (${leastValuableUsersCount})`}
              </ChartDataLabel>
            </ContentRightColumn>
          </ContentFlexColumns>
          <DataDetails
            title={extraDetailsTitle}
            color={extraDetailsColor}
            data={extraDetailsData}
          />
        </ContentContainer>
      </Wrapper>
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default MostLeastValuablePlayers;



// WEBPACK FOOTER //
// ./src/instructor/components/peer-feedback/pages/dynamics/individual/most-least-valuable-players.js